import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/usecase';
import { HttpResponseEntity } from '../../domain/common.models';
import { PinValidationData } from '../../domain/pin-creation-domain.models';
import { FSWalletPinTransactionRepository } from '../../repository/fs-wallet-pin-transaction.repository';

/**
 * Check PIN Use Case - Clean Architecture Application Layer
 * Validates PIN format and business rules via API
 */
@Injectable({ providedIn: 'root' })
export class CheckPinUsecase implements UseCase<PinValidationData, HttpResponseEntity> {
    constructor(private repository: FSWalletPinTransactionRepository) {}

    /**
     * Execute PIN validation
     * @param data - Domain data for PIN validation
     * @returns Observable of domain entity
     */
    execute(data: PinValidationData): Observable<HttpResponseEntity> {
        // Add default action if not provided
        const validationData: PinValidationData = {
            ...data,
            action: data.action || 'create',
        };

        return this.repository.CheckPin(validationData);
    }
}
